import { ICameraInfo, PARTIAL_UNSUPPORT_MODELS } from '@thingsw/pitta-modules';

export const getPatialUnsupportModel = (camera: ICameraInfo | undefined) => {
  let isPartialUnsupport = false;

  PARTIAL_UNSUPPORT_MODELS.forEach((model) => {
    if (camera?.model.includes(model)) {
      isPartialUnsupport = true;
    }
  });

  return isPartialUnsupport;
};
